import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 特定商取引法に基づく表記 商品の引き渡し時期
 */
export class SctActDeliveryTime extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SctActDeliveryTime {
    return new SctActDeliveryTime(value);
  }
}
